
const TrustedBySection = () => {
  const metrics = [
    {
      icon: 'ri-line-chart-line',
      value: '500%',
      label: 'Average Revenue Increase',
      description: 'Our clients see massive growth within 6 months'
    },
    {
      icon: 'ri-search-line',
      value: '#1',
      label: 'Search Rankings Achieved',
      description: 'Dominate page 1 for high-value keywords'
    },
    {
      icon: 'ri-time-line',
      value: '90',
      label: 'Days to Results',
      description: 'See significant improvements in 3 months'
    },
    {
      icon: 'ri-store-line',
      value: '200+',
      label: 'Businesses Transformed',
      description: 'From local shops to online leaders'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Inter, sans-serif' }}>
            Proven Results That
            <span className="text-indigo-600"> Speak Volumes</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" style={{ fontFamily: 'Inter, sans-serif' }}>
            We don't just promise growth – we deliver measurable results that transform businesses and dominate markets.
          </p>
        </div>

        {/* Metrics Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {metrics.map((metric, index) => (
            <div key={index} className="bg-white rounded-2xl p-8 text-center shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
              <div className="w-16 h-16 bg-indigo-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className={`${metric.icon} text-2xl text-indigo-600`}></i>
              </div>
              <div className="text-4xl font-bold text-gray-900 mb-2" style={{ fontFamily: 'JetBrains Mono, monospace' }}>
                {metric.value}
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-3" style={{ fontFamily: 'Inter, sans-serif' }}>
                {metric.label}
              </h3>
              <p className="text-gray-600 text-sm" style={{ fontFamily: 'Inter, sans-serif' }}>
                {metric.description}
              </p>
            </div>
          ))}
        </div>

        {/* Client Logos */}
        <div className="mt-20 pt-12 border-t border-gray-200">
          <p className="text-center text-gray-500 mb-8" style={{ fontFamily: 'Inter, sans-serif' }}>
            Powering growth for innovative brands
          </p>
          <div className="grid grid-cols-2 md:grid-cols-6 gap-8 items-center opacity-60">
            <div className="text-center">
              <div className="text-2xl font-bold text-gray-400">TechStart</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-gray-400">LocalPro</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-gray-400">ShopMax</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-gray-400">GrowthCo</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-gray-400">ScaleUp</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-gray-400">RankFirst</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustedBySection;
